import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { SupabaseProvider } from './contexts/SupabaseContext';
import { MapProvider } from './contexts/MapContext';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import Discover from './pages/Discover';
import StoryPage from './pages/StoryPage';
import Login from './pages/Login';
import Register from './pages/Register';
import CreatePost from './pages/CreatePost';
import PostsPage from './pages/PostsPage';
import AdminPortal from './pages/Admin/AdminPortal';
import ProtectedRoute from './components/Auth/ProtectedRoute';

function App() {
  return (
    <SupabaseProvider>
      <MapProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/discover" element={<Layout><Discover /></Layout>} />
              <Route path="/story/:slug" element={<Layout><StoryPage /></Layout>} />
              <Route path="/posts" element={<Layout><PostsPage /></Layout>} />
              <Route path="/posts/:id" element={<Layout><PostsPage /></Layout>} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route 
                path="/create-post" 
                element={
                  <ProtectedRoute>
                    <CreatePost />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/control-center" 
                element={
                  <ProtectedRoute adminOnly>
                    <AdminPortal />
                  </ProtectedRoute>
                } 
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster 
              position="top-right"
              toastOptions={{
                className: 'bg-white text-gray-900 shadow-lg border border-gray-200',
                duration: 4000,
              }}
            />
          </div>
        </Router>
      </MapProvider>
    </SupabaseProvider>
  );
}

export default App;
